<template>
    <v-container fluid style=""> 
    
     <v-row>
        <v-spacer></v-spacer>
        <v-btn style=" font-size: 0.9em; font-weight: 400;" color="#185EA9" text @click="onAddFilter()"  >Añadir acción</v-btn>
    </v-row>
    <v-row > 
       <v-data-table :disableFiltering="true" style="width:100%; margin: 0;"
             :headers="headers" :class="'row-pointer'"
             ref = "dataTable"
             :items="data" 
             :fixedHeader="true" 
             :height="tableHeight"
             @click:row="filter => onEditFilter(filter)"
         >
            <template v-slot:item.icon="{ item }">
                <v-icon small>{{ item.icon }}</v-icon >
            </template>
         </v-data-table>
      </v-row>

      <v-dialog v-model="editDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            Editar acción
          </v-card-title>
          <v-card-text>
            <v-form ref="filterForm">
              <v-row style="width:100%; margin: 0;">
                <v-col cols="6">
                    <v-text-field
                        v-model="editOption.icon"
                        :label="'Icon'" :rules="[validationRules.required]"
                        autocomplete="none"
                        max="300"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="editOption.label"
                        :label="'Label'" :rules="[validationRules.required]"
                        :hint="$t(editOption.label)" persistent-hint
                        autocomplete="none"
                        max="300"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editOption.mode"
                        :label="'Mode'" 
                        :items="optionModes"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editOption.type"
                        :label="'Type'" 
                        :items="currentOptionTypes"
                    />
                </v-col>
                <v-col cols="6">
                    <v-select
                        v-model="editOption.action"
                        :label="'Type'" 
                        :items="optionActions"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        v-model="editOption.payload"
                        autocomplete="none"
                        max="50"
                    />
                </v-col>
            </v-row>
            </v-form>

          </v-card-text> 
          <v-card-actions>
            <v-btn v-if="editedIndex>-1" color="#ff0000" @click="onDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="onCancelEdit()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
 
     </v-container>
 </template>
 
 <script> 
 
 import BaseModule from '../../../common/BaseModule.js'
 import { Constants } from '../../../common/Constants'

 export default {
   name: 'FilterEditor',
   mixins: [BaseModule],
   components: { 
    
   },
    props: ['options'],
   
   data() {
       return {
         headers: [
                    
                    { text: 'Icon', value: 'icon', width:'20px' },
                    { text: 'Label', value: 'label' },
                    { text: 'Mode', value: 'mode' },
                    { text: 'Type', value: 'type' },
                    { text: 'Action', value: 'action' },
                    { text: 'Payload', value: 'payload' },],
         data: [],
         editedIndex: -1,
         editOption: {},
         tableHeight:300,
         optionModes:[],
         optionTypes:{},
         optionActions:[],
         editDialog: false
       }
   }, mounted() {
        this.data = this.options?this.options:[];
        this.optionModes = Constants.eventModes;
        this.optionTypes = Constants.eventTypes;
        this.optionActions = Constants.eventActions;
    },watch: {
       context: function() { 
        
      },
      options: function(options) { 
        this.data = options?options:[];
    }
     },
     computed: {
        // a computed getter
        currentOptionTypes() {
        if (!this.editOption || !this.editOption.mode) {
            return [];
        }
        return this.optionTypes[this.editOption.mode];
      }
    },
    methods: { 
        onAddFilter() {
            this.editedIndex = -1;
            this.editDialog=true;
            this.editOption = { 
                fields: []
            };
        },
        onEditFilter(filter) {
            this.editedIndex = this.data.indexOf(filter);
            this.editDialog=true;
            this.editOption =  Object.assign({}, filter);
        },
        onCancelEdit() {
            this.editDialog=false;
            this.editOption = {};
        },
        onDelete () {
            this.data.splice(this.editedIndex, 1)
            this.editDialog=false;
            this.editOption = {};
        },
        onSave() {
            if (!this.$refs.filterForm.validate()) {
					return;
			}

            if (this.editedIndex > -1) {
                Object.assign(this.data[this.editedIndex], this.editOption)
            } else {
                this.data.push(this.editOption)
            }

            this.editDialog=false;
            this.editOption = {};
        }
    }
 };
 </script>
  